<template>
  <div>
    <MainHeader />
    <div
      class="timeline-container"
      v-if="state.isempty">
      <div class="lineleft">
        <div>
          <div class="entry-list">
            <div class="infor-list">
              <div class="flow-header">
                <a :href="`/user/${DetailInfo.uuid}`" target="_blank">
                <div class="user">
                  <img
                    :src="DetailInfo.avatar_url"
                    class="avatar" />
                  <div class="info">
                    <span class="nickname">{{ DetailInfo.author }}</span>
                    <div class="date">{{ DetailInfo.created_at }} 创建</div>
                  </div>
                </div>
              </a>
              </div>
              <h1 class="title">{{ DetailInfo.title }}</h1>
              <div class="content post-content">
                <Viewer
                  ref="markDownRef"
                  :locale="zh"
                  :value="value"
                  :plugins="plugins" />
              </div>
              <!-- <div class="tagslist">
                <span class="post_tag">#标签&nbsp;</span>
              </div> -->
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="sidebar-container">
          <UserItem :user-id="DetailInfo.uuid" />
        </div>
      </div>
    </div>
    <div
      class="empty-list"
      v-if="!state.isempty">
      <div class="null-infor-list">
        <div class="content-flag">
          <div class="common-empty">
            <img src="@/assets/img/404.png" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, reactive, toRefs, markRaw, ref } from "vue";
import MainHeader from "@/components/main-header.vue";
import UserItem from "@/components/User-Item.vue";

import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import axiosInstance from "@/utils/axiosInstance";

import { Viewer } from "@bytemd/vue-next";

import gfm from "@bytemd/plugin-gfm";
import "bytemd/dist/index.css";

// 突出显示代码块
import highlight from "@bytemd/plugin-highlight";
import "highlight.js/styles/default.css";

// 对齐方式
import alignPlugin from "bytemd-plugin-align";
// 主题
import theme from "bytemd-plugin-theme";
// 解析前言 格式化
import frontmatter from "@bytemd/plugin-frontmatter";
// 表情
import gemoji from "@bytemd/plugin-gemoji";

// 代码高亮
import highLightPlugin from "bytemd-plugin-highlight";
// 图片的缩放
import imagePlugin from "bytemd-plugin-image";
// 代码复制
import copyCode from "bytemd-plugin-copy-code";
import "bytemd-plugin-copy-code/dist/style/index.css";

// 缩放图片 点击图片放大,再点击缩小
import mediumZoom from "@bytemd/plugin-medium-zoom";
// 图表
import mermaid from "@bytemd/plugin-mermaid";
import mermaidLocale from "@bytemd/plugin-mermaid/locales/zh_Hans.json";
// 数学公式插件
import math from "@bytemd/plugin-math";
import mathLocale from "@bytemd/plugin-math/locales/zh_Hans.json";
import "katex/dist/katex.css";

import zhHans from "bytemd/locales/zh_Hans.json";
import { useHead } from "@vueuse/head";
import { WebSite_Name } from "@/interface/globalindex";

const SSRData = ref({
  title: "",
  description: "",
  keywords: "宁波技术社区,默认代码,程序员中文技术社区,前端开发社区,前端技术交流,前端框架教程",
});

// 插件
const pluginsList = [
  gfm(),
  math({
    locale: mathLocale,
  }),
  alignPlugin(),
  highLightPlugin(),
  imagePlugin(),
  copyCode({
    copySuccess: (text) => {
      console.log(text);
      ElMessage.success("代码复制成功");
    },
    copyError: (err) => {
      console.log(err);
    },
  }),
  mediumZoom(),
  mermaid({
    locale: mermaidLocale,
  }),
  highlight(),
  theme(),
  frontmatter(),
  gemoji(),
];

const router = useRouter();

// 编辑器数据初始化
const state = reactive({
  value: "",
  plugins: markRaw(pluginsList),
  zh: zhHans,
  isempty: ref(true),
});

const { value, plugins, zh, markDownRef } = toRefs(state);

//文章信息
const DetailInfo = reactive({
  article_id: "",
  title: "",
  info_content: "",
  category_id: "",
  category_name: "",
  brief_content: "",
  link_url: "",
  cover_image: "",
  comment_count: "",
  view_count: "",
  digg_count: "",
  favorited_count: "",
  is_markdown: "",
  is_hot: "",
  uuid: "",
  author: "",
  created_at: "",
  avatar_url: ""
});

onMounted(async () => {
  //获取文章ID 参数
  const postID = router.currentRoute.value.params.postID as string;
  fetchArticleInfoData(postID);
});

// 获取文章数据
const fetchArticleInfoData = async (postID: string) => {
  try {
    await axiosInstance
      .get("/api/HomeArticle/detail", {
        params: { article_id: postID },
      })
      .then((res) => {
        var result = res.data;
        if (result.success) {
          const articleData = result.data;
          DetailInfo.article_id = articleData.article_id;
          DetailInfo.title = articleData.title;
          DetailInfo.info_content = articleData.info_content;
          DetailInfo.category_id = articleData.category_id;
          DetailInfo.category_name = articleData.category_name;
          DetailInfo.brief_content = articleData.brief_content;
          DetailInfo.link_url = articleData.link_url;
          DetailInfo.cover_image = articleData.cover_image;
          DetailInfo.comment_count = articleData.comment_count;
          DetailInfo.view_count = articleData.view_count;
          DetailInfo.digg_count = articleData.digg_count;
          DetailInfo.favorited_count = articleData.favorited_count;
          DetailInfo.is_markdown = articleData.is_markdown;
          DetailInfo.is_hot = articleData.is_hot;
          DetailInfo.uuid = articleData.uuid;
          DetailInfo.author = articleData.author;
          DetailInfo.avatar_url = articleData.avatar_url;
          DetailInfo.created_at = articleData.created_at;
          state.value = articleData.info_content;
          //SEO 内容
          SSRData.value.title = articleData.title+' - '+WebSite_Name;
          SSRData.value.description = articleData.brief_content;
        } else {
          state.isempty = false;
          //SEO 内容
          SSRData.value.title = '找不到页面';
          SSRData.value.description = '';
          SSRData.value.keywords = '';
        }
        setSSRHead();
      });
  } catch (error) {
    ElMessage.error("获取文章数据失败");
  }
};

//动态设置SEO 信息
const setSSRHead = () => {
  useHead({
    title: SSRData.value.title,
    meta: [
      { name: "description", content: SSRData.value.description },
      { name: "keywords", content: SSRData.value.keywords },
    ],
  });
};
</script>

<style scoped>
/*文章列表 */
.timeline-container {
  display: flex;
  justify-content: space-between;
  max-width: 1020px;
  margin: 20px auto;
}
.lineleft {
  min-width: 720px;
  margin-right: 15px;
  background: #fff;
}

.entry-list {
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
}
/*信息流 */
.infor-list {
  font-size: 16px;
  line-height: 26px;
  border-bottom: 1px solid #e5e5e5;
  padding: 10px 0 20px;
}
.flow-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
  cursor: pointer;
}
.flow-header .user {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.flow-header .user .avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 6px;
}
.flow-header .user span {
  font-size: 14px;
  font-weight: 900;
}
.flow-header .info {
  font-size: 12px;
  color: #ababae;
}
.flow-header .user .nickname {
  flex: 1;
  font-size: 14px;
  line-height: 20px;
  color: #353535;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: pointer;
}
.flow-header .user .date {
  font-size: 12px;
  line-height: 12px;
  color: #ababae;
  margin-top: 2px;
}
.flow-header .user .info {
  margin-left: 10px;
  align-items: center;
}
.content-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 1 auto;
  margin-top: 10px;
  position: relative;
}
.title {
  font-size: 26px;
}
.content {
  margin: 0;
  color: #333;
}
.content a {
  color: #b14b43;
  text-decoration: none;
}
.thumbnail {
  width: min(197px, calc(33.33333vw - 16px));
  height: min(197px, calc(33.33333vw - 16px));
  margin: 0 4px 4px 0;
  -o-object-fit: cover;
  object-fit: cover;
}
.thumbnail:nth-of-type(3n) {
  margin-right: 0;
}
.files {
  display: flex;
  flex-wrap: wrap;
  margin-top: 4px;
}
.post_tag {
  font-size: 15px;
  line-height: 21px;
  color: #64a1bc;
  cursor: pointer;
}
.tagslist {
  margin-top: 5px;
}
/*
右侧
*/
.sidebar-container {
  background: #fffdfc;
  mix-blend-mode: normal;
  -webkit-backdrop-filter: blur(40px);
  backdrop-filter: blur(40px);
  border-radius: 6px;
  margin-bottom: 20px;
  padding: 18px 19px;
  width: 262px;
  margin-left: 15px;
}

/* 编辑器相关样式 */
::v-deep .markdown-body img {
  max-width: 100%;
}

::v-deep .el-radio__inner {
  display: none;
}
::v-deep .el-radio {
  width: 98px;
  margin-right: 9px;
  margin-bottom: 10px;
}
::v-deep .markdown-body {
  word-break: break-word;
  line-height: 1.75;
  font-weight: 400;
  font-size: 16px;
  overflow-x: hidden;
  color: #252933;
}
::v-deep .markdown-body h1,
::v-deep .markdown-body h2,
::v-deep .markdown-body h3,
::v-deep .markdown-body h4,
::v-deep .markdown-body h5,
::v-deep .markdown-body h6 {
  line-height: 1.5;
  margin-top: 35px;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
::v-deep .markdown-body h1 {
  font-size: 24px;
  line-height: 38px;
  margin-bottom: 5px;
}
::v-deep .markdown-body h2 {
  font-size: 22px;
  line-height: 34px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ececec;
}
::v-deep .markdown-body h3 {
  font-size: 20px;
  line-height: 28px;
}
::v-deep .markdown-body h4 {
  font-size: 18px;
  line-height: 26px;
}
::v-deep .markdown-body h5 {
  font-size: 17px;
  line-height: 24px;
}
::v-deep .markdown-body h6 {
  font-size: 16px;
  line-height: 24px;
}
::v-deep .markdown-body p {
  line-height: inherit;
  margin-top: 22px;
  margin-bottom: 22px;
}
::v-deep .markdown-body img {
  max-width: 100%;
}
::v-deep .markdown-body hr {
  border: none;
  border-top: 1px solid #ddd;
  margin-top: 32px;
  margin-bottom: 32px;
}
::v-deep .markdown-body code {
  word-break: break-word;
  border-radius: 2px;
  overflow-x: auto;
  background-color: #fff5f5;
  color: #ff502c;
  font-size: 0.87em;
  padding: 0.065em 0.4em;
}
::v-deep .markdown-body code,
::v-deep .markdown-body pre {
  font-family: Menlo, Monaco, Consolas, Courier New, monospace;
}
::v-deep .markdown-body pre {
  overflow: auto;
  position: relative;
  line-height: 1.75;
}
::v-deep .markdown-body pre > code {
  font-size: 12px;
  padding: 15px 12px;
  margin: 0;
  word-break: normal;
  display: block;
  overflow-x: auto;
  color: #333;
  background: #f8f8f8;
}
::v-deep .markdown-body a {
  text-decoration: none;
  color: #0269c8;
  border-bottom: 1px solid #d1e9ff;
}
::v-deep .markdown-body a:active,
::v-deep .markdown-body a:hover {
  color: #275b8c;
}
::v-deep .markdown-body table {
  display: inline-block !important;
  font-size: 12px;
  width: auto;
  max-width: 100%;
  overflow: auto;
  border: 1px solid #f6f6f6;
}
::v-deep .markdown-body thead {
  background: #f6f6f6;
  color: #000;
  text-align: left;
}
::v-deep .markdown-body tr:nth-child(2n) {
  background-color: #fcfcfc;
}
::v-deep .markdown-body td,
::v-deep .markdown-body th {
  padding: 12px 7px;
  line-height: 24px;
}
::v-deep .markdown-body td {
  min-width: 120px;
}
::v-deep .markdown-body blockquote {
  color: #666;
  padding: 1px 23px;
  margin: 22px 0;
  border-left: 4px solid #cbcbcb;
  background-color: #f8f8f8;
}
::v-deep .markdown-body blockquote:after {
  display: block;
  content: "";
}
::v-deep .markdown-body blockquote > p {
  margin: 10px 0;
}
::v-deep .markdown-body ol,
::v-deep .markdown-body ul {
  padding-left: 28px;
}
::v-deep .markdown-body ol li,
::v-deep .markdown-body ul li {
  margin-bottom: 0;
  list-style: inherit;
}
::v-deep .markdown-body ol li .task-list-item,
::v-deep .markdown-body ul li .task-list-item {
  list-style: none;
}
::v-deep .markdown-body ol li .task-list-item ol,
::v-deep .markdown-body ol li .task-list-item ul,
::v-deep .markdown-body ul li .task-list-item ol,
::v-deep .markdown-body ul li .task-list-item ul {
  margin-top: 0;
}
::v-deep .markdown-body ol ol,
::v-deep .markdown-body ol ul,
::v-deep .markdown-body ul ol,
::v-deep .markdown-body ul ul {
  margin-top: 3px;
}
::v-deep .markdown-body ol li {
  padding-left: 6px;
}
::v-deep .markdown-body .contains-task-list {
  padding-left: 0;
}
::v-deep .markdown-body .task-list-item {
  list-style: none;
}
@media (max-width: 720px) {
  ::v-deep .markdown-body h1 {
    font-size: 24px;
  }
  ::v-deep .markdown-body h2 {
    font-size: 20px;
  }
  ::v-deep .markdown-body h3 {
    font-size: 18px;
  }
}

/* 编辑器相关样式 */
::v-deep .markdown-body img {
  max-width: 100%;
}

::v-deep .el-radio__inner {
  display: none;
}
::v-deep .el-radio {
  width: 98px;
  margin-right: 9px;
  margin-bottom: 10px;
}
::v-deep .markdown-body {
  word-break: break-word;
  line-height: 1.75;
  font-weight: 400;
  font-size: 16px;
  overflow-x: hidden;
  color: #252933;
}
::v-deep .markdown-body h1,
::v-deep .markdown-body h2,
::v-deep .markdown-body h3,
::v-deep .markdown-body h4,
::v-deep .markdown-body h5,
::v-deep .markdown-body h6 {
  line-height: 1.5;
  margin-top: 35px;
  margin-bottom: 10px;
  padding-bottom: 5px;
}
::v-deep .markdown-body h1 {
  font-size: 24px;
  line-height: 38px;
  margin-bottom: 5px;
}
::v-deep .markdown-body h2 {
  font-size: 22px;
  line-height: 34px;
  padding-bottom: 12px;
  border-bottom: 1px solid #ececec;
}
::v-deep .markdown-body h3 {
  font-size: 20px;
  line-height: 28px;
}
::v-deep .markdown-body h4 {
  font-size: 18px;
  line-height: 26px;
}
::v-deep .markdown-body h5 {
  font-size: 17px;
  line-height: 24px;
}
::v-deep .markdown-body h6 {
  font-size: 16px;
  line-height: 24px;
}
::v-deep .markdown-body p {
  line-height: inherit;
  margin-top: 22px;
  margin-bottom: 22px;
}
::v-deep .markdown-body img {
  max-width: 100%;
}
::v-deep .markdown-body hr {
  border: none;
  border-top: 1px solid #ddd;
  margin-top: 32px;
  margin-bottom: 32px;
}
::v-deep .markdown-body code {
  word-break: break-word;
  border-radius: 2px;
  overflow-x: auto;
  background-color: #fff5f5;
  color: #ff502c;
  font-size: 0.87em;
  padding: 0.065em 0.4em;
}
::v-deep .markdown-body code,
::v-deep .markdown-body pre {
  font-family: Menlo, Monaco, Consolas, Courier New, monospace;
}
::v-deep .markdown-body pre {
  overflow: auto;
  position: relative;
  line-height: 1.75;
}
::v-deep .markdown-body pre > code {
  font-size: 12px;
  padding: 15px 12px;
  margin: 0;
  word-break: normal;
  display: block;
  overflow-x: auto;
  color: #333;
  background: #f8f8f8;
}
::v-deep .markdown-body a {
  text-decoration: none;
  color: #0269c8;
  border-bottom: 1px solid #d1e9ff;
}
::v-deep .markdown-body a:active,
::v-deep .markdown-body a:hover {
  color: #275b8c;
}
::v-deep .markdown-body table {
  display: inline-block !important;
  font-size: 12px;
  width: auto;
  max-width: 100%;
  overflow: auto;
  border: 1px solid #f6f6f6;
}
::v-deep .markdown-body thead {
  background: #f6f6f6;
  color: #000;
  text-align: left;
}
::v-deep .markdown-body tr:nth-child(2n) {
  background-color: #fcfcfc;
}
::v-deep .markdown-body td,
::v-deep .markdown-body th {
  padding: 12px 7px;
  line-height: 24px;
}
::v-deep .markdown-body td {
  min-width: 120px;
}
::v-deep .markdown-body blockquote {
  color: #666;
  padding: 1px 23px;
  margin: 22px 0;
  border-left: 4px solid #cbcbcb;
  background-color: #f8f8f8;
}
::v-deep .markdown-body blockquote:after {
  display: block;
  content: "";
}
::v-deep .markdown-body blockquote > p {
  margin: 10px 0;
}
::v-deep .markdown-body ol,
::v-deep .markdown-body ul {
  padding-left: 28px;
}
::v-deep .markdown-body ol li,
::v-deep .markdown-body ul li {
  margin-bottom: 0;
  list-style: inherit;
}
::v-deep .markdown-body ol li .task-list-item,
::v-deep .markdown-body ul li .task-list-item {
  list-style: none;
}
::v-deep .markdown-body ol li .task-list-item ol,
::v-deep .markdown-body ol li .task-list-item ul,
::v-deep .markdown-body ul li .task-list-item ol,
::v-deep .markdown-body ul li .task-list-item ul {
  margin-top: 0;
}
::v-deep .markdown-body ol ol,
::v-deep .markdown-body ol ul,
::v-deep .markdown-body ul ol,
::v-deep .markdown-body ul ul {
  margin-top: 3px;
}
::v-deep .markdown-body ol li {
  padding-left: 6px;
}
::v-deep .markdown-body .contains-task-list {
  padding-left: 0;
}
::v-deep .markdown-body .task-list-item {
  list-style: none;
}
@media (max-width: 720px) {
  ::v-deep .markdown-body h1 {
    font-size: 24px;
  }
  ::v-deep .markdown-body h2 {
    font-size: 20px;
  }
  ::v-deep .markdown-body h3 {
    font-size: 18px;
  }
}

/*代码高亮 */

::v-deep .code-block-extension-header {
  display: flex;
  /* background-color: inherit; */
  user-select: none;
  height: 28px;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0px 4px 5px -6px #888888;
  margin-bottom: 3px;
}
::v-deep .code-block-extension-header ::v-deep .code-block-extension-fold {
  box-shadow: none;
  margin-bottom: 0;
}
::v-deep .code-block-extension-headerLeft,
::v-deep .code-block-extension-headerRight {
  display: flex;
  align-items: center;
}
::v-deep .code-block-extension-headerLeft {
  margin-left: 10px;
}
::v-deep .code-block-extension-headerRight {
  margin-right: 10px;
}

::v-deep
  .code-block-extension-headerLeft
  > ::v-deep
  .code-block-extension-foldBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  filter: invert(0.8);
}
::v-deep
  .code-block-extension-headerLeft
  > ::v-deep
  .code-block-extension-foldBtn:hover {
  filter: invert(0.5);
  cursor: pointer;
}
::v-deep .code-block-extension-foldBtn > svg {
  height: 100%;
}
::v-deep
  .code-block-extension-headerLeft
  > ::v-deep
  .code-block-extension-foldBtn
  ::v-deep
  .code-block-extension-fold {
  transform: rotate(-90deg);
}
::v-deep .code-block-extension-lang {
  margin-left: 20px;
  font-size: 12px;
  filter: invert(0.5);
  opacity: 0.6;
}

::v-deep .code-block-extension-copyCodeBtn {
  font-size: 12px;
  filter: invert(0.5);
  margin: 0 10px;
  opacity: 0.6;
}
::v-deep .code-block-extension-copyCodeBtn:hover {
  filter: invert(0.7);
  cursor: pointer;
}

::v-deep pre > ::v-deep code.code-block-extension-fold {
  display: none !important;
}

::v-deep pre > ::v-deep code.code-block-extension-codeShowNum {
  padding-left: 0 !important;
}

::v-deep
  .code-block-extension-lineNumHide
  ::v-deep
  .code-block-extension-codeLine:before {
  display: none !important;
}

::v-deep .code-block-extension-codeLine {
  background-color: inherit;
}
::v-deep .code-block-extension-codeLine:before {
  content: attr(data-line-num);
  color: gray;
  user-select: none;
  background-color: inherit;
  text-align: center;
  display: inline-block;
  width: 18px;
  padding: 0 10px;
  box-sizing: content-box;
  position: sticky;
  left: 0;
}

::v-deep .code-block-extension-lineNumBtnContainer {
  display: flex;
  align-items: center;
}
::v-deep .code-block-extension-lineNumText {
  filter: invert(0.5);
  font-size: 12px;
  margin-left: 3px;
}
::v-deep .code-block-extension-lineNumCheckbox::before {
  display: none !important;
}
::v-deep .copy-code-btn {
  display: none !important;
}
::v-deep .hljs[lang]::before {
  display: none !important;
}

/*404 界面 */
.empty-list {
  padding: 12px 20px;
  border-radius: 8px 8px 0 0;
  background: #fff;
  min-width: 800px;
  min-height: 725px;
}
.null-infor-list {
  font-size: 16px;
  line-height: 26px;
  padding: 10px 0 20px;
  margin-top: 51px;
}
.content-flag {
  font-size: 16px;
  font-weight: 400;
  color: #8a919f;
  margin-top: 50px;
}
.common-empty {
  display: flex;
  justify-content: center;
  margin-bottom: 8px;
}
</style>
